// extracted by mini-css-extract-plugin
export default {"group":"NameDescriptionFields_group__sXH2X"};